var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"count-down-btn",attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.handleClicked.apply(null, arguments)}}},[_vm._v("\n  "+_vm._s(_vm.message || _vm.initTip)+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71659ff9","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CountDownBtn.vue
// module id = null
// module chunks = 